import {
    Card,
    CardContent,
    CardHeader,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid2,
    IconButton,
    Stack,
    Switch,
} from "@mui/material";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialInput from "../../../components/MaterialInput";
import MaterialBox from "../../../components/MaterialBox";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import MaterialButton from "../../../components/MaterialButton";
import DashboardFooter from "../../../layoutcontainers/DashboardLayout/components/Footer";
import { fetchData, fetchDataById, postData, putData } from "../../../services";
import { useEffect, useReducer, useState } from "react";
import { handelChange } from "../../../reducers/formReducer";
import MaterialSelect from "../../../components/MasterSelect";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";

const initialState = {
    generalInsurerId: {},
    generalInsurerIdErr: "unchecked",
    generalFinancerId: {},
    generalFinancerIdErr: "unchecked",
    code: "",
    codeErr: "unchecked",
    name: "",
    nameErr: "unchecked",
    isActive: false,
};

const InsurerFinancerForm = () => {
    
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();
    const [state, dispatch] = useReducer(handelChange, initialState);
    const [dropdown, setDropdown] = useState({
        insurer: [],
        financer: [],
    });

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const Id = searchParams.get("id");
    const pageType = searchParams.get("pageType");


    const pageMode =
        pageType === "view" ? "view" : pageType === "edit" ? "edit" : "add";

    useEffect(() => {
        const fetchInsurerList = async () => {
            setCircleLoading(true);
            try {
                const response = await fetchData(
                    `/reference/general/insurer-master?dropdown=true&isActive=true`
                );

                setDropdown((prev) => ({
                    ...prev,
                    insurer: response?.data?.items?.map((item) => ({
                        value: item?.id,
                        label: item?.companyName,
                    })),
                }));
            } catch (error) {
                console.error("Error Fetching Insurer List:", error);
            } finally {
                setCircleLoading(false);
            }
        };

        fetchInsurerList();
    }, []);

    useEffect(() => {
        const fetchFinancerList = async () => {
            setCircleLoading(true);
            try {
                const response = await fetchData(
                    `/reference/general/financer-list-master?dropdown=true&isActive=true`
                );

                setDropdown((prev) => ({
                    ...prev,
                    financer: response?.data?.items?.map((item) => ({
                        value: item?.id,
                        label: item?.name,
                    })),
                }));
            } catch (error) {
                console.error("Error Fetching Financer List:", error);
                showSnackbar(error?.response?.data?.message, "error");
            } finally {
                setCircleLoading(false);
            }
        };

        fetchFinancerList();
    }, []);

    useEffect(() => {
        const fetchFinancerById = async () => {
            setCircleLoading(true);
            try {
                const data = await fetchDataById(`/reference/insurer/financer/${Id}`);
                const responseData = data?.data?.financer;

                if (data?.success) {
                    dispatch({
                        type: "bulkUpdate",
                        payload: {
                            generalInsurerId: {
                                value: responseData?.gInsurerId,
                                label: responseData?.gInsurerName,
                            },
                            generalFinancerId: {
                                value: responseData?.gFinancerId,
                                label: responseData?.gFinancerName,
                            },
                            code: responseData?.code,
                            name: responseData?.name,
                            isActive: responseData?.isActive,
                        },
                    });
                }
            } catch (error) {
                console.error("Error fetching data by ID:", error);
            } finally {
                setCircleLoading(false);
            }
        };
        if (Id) {
            fetchFinancerById();
        }
    }, [Id]);

    const handelSubmit = async () => {
        const payload = {
            gInsurerId: state?.generalInsurerId?.value,
            gFinancerId: state?.generalFinancerId?.value,
            code: state?.code,
            name: state?.name,
            isActive: state?.isActive,
        };
        if (pageMode === "edit") {
            try {
                setCircleLoading(true);
                const response = await putData(
                    `/reference/insurer/financer/${Id}`,
                    payload
                );
                const responseMessage = response?.message;
                if (response?.success) {
                    showSnackbar(responseMessage, "success");
                    navigate("/insurer-master/insurer-financer");
                } else {
                    showSnackbar(responseMessage, "error");
                }
            } catch (error) {
                showSnackbar(error?.response?.data?.message, "error");
            } finally {
                setCircleLoading(false);
            }
        } else {
            try {
                setCircleLoading(true);
                const response = await postData("/reference/insurer/financer", payload);
                const responseMessage = response?.message;
                if (response?.success) {
                    showSnackbar(responseMessage, "success");
                    navigate("/insurer-master/insurer-financer");
                } else {
                    showSnackbar(responseMessage, "error");
                }
            } catch (error) {
                showSnackbar(error?.response?.data?.message, "error");
            } finally {
                setCircleLoading(false);
            }
        }
    };

    const checkAllFields = () => {
        let allowSubmit = false;

        if (
            state.generalInsurerIdErr === "success" &&
            state.generalFinancerIdErr === "success" &&
            state.codeErr === "success" &&
            state.nameErr === "success"
        ) {
            allowSubmit = false;
        } else {
            allowSubmit = true;
        }

        return allowSubmit;
    };

    return (
        <>
            <DashboardLayout>
                <Card sx={{ minHeight: 500 }}>
                    <CardHeader
                        title={
                            <Stack
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                spacing={2}
                            >
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <IconButton
                                        onClick={() =>
                                            navigate("/insurer-master/insurer-financer")
                                        }
                                    >
                                        <ArrowBack />
                                    </IconButton>
                                    <Stack direction="column" spacing={0}>
                                        <MaterialTypography variant="h5" fontWeight="medium">
                                            Financer Details
                                        </MaterialTypography>
                                        <MaterialTypography variant="caption" color="text">
                                            Enter New Financer Details from around the world.
                                        </MaterialTypography>
                                    </Stack>
                                </Stack>
                            </Stack>
                        }
                    />

                    <CardContent>
                        <Grid2 container spacing={2}>
                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox>
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        General Insurer <span className="span">*</span>
                                    </MaterialTypography>
                                </MaterialBox>
                                <MaterialSelect
                                    name="generalInsurerId"
                                    options={dropdown?.insurer}
                                    value={state?.generalInsurerId}
                                    onChange={(e) =>
                                        dispatch({
                                            type: "Select",
                                            value: e,
                                            name: "generalInsurerId",
                                        })
                                    }
                                    success={state?.generalInsurerIdErr === "success"}
                                    error={state.generalInsurerIdErr === "error"}
                                    isDisabled={pageMode === "view"}
                                />
                            </Grid2>
                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox>
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        General Financer <span className="span">*</span>
                                    </MaterialTypography>
                                </MaterialBox>
                                <MaterialSelect
                                    name="generalFinancerId"
                                    options={dropdown?.financer}
                                    value={state?.generalFinancerId}
                                    onChange={(e) =>
                                        dispatch({
                                            type: "Select",
                                            value: e,
                                            name: "generalFinancerId",
                                        })
                                    }
                                    success={state?.generalFinancerIdErr === "success"}
                                    error={state.generalFinancerIdErr === "error"}
                                    isDisabled={pageMode === "view"}
                                />
                            </Grid2>

                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox>
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        Code <span className="span">*</span>
                                    </MaterialTypography>
                                </MaterialBox>
                                <MaterialInput
                                    name="code"
                                    value={state?.code}
                                    onChange={(e) =>
                                        dispatch({
                                            value: e?.target?.value,
                                            name: "code",
                                            type: "input",
                                            regex: "^([\\s\\S]{1,20})$",
                                        })
                                    }
                                    success={state?.codeErr === "success"}
                                    error={state.codeErr === "error"}
                                    disabled={pageMode === "view"}
                                />
                                {state.codeErr === "error" && (
                                    <FormControl error>
                                        <FormHelperText>
                                            Code should be a minimum 1 character & maximum 20
                                            characters long.
                                        </FormHelperText>
                                    </FormControl>
                                )}
                            </Grid2>
                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox>
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        Name <span className="span">*</span>
                                    </MaterialTypography>
                                </MaterialBox>
                                <MaterialInput
                                    name="name"
                                    value={state?.name}
                                    onChange={(e) =>
                                        dispatch({
                                            value: e?.target?.value,
                                            name: "name",
                                            type: "input",
                                            regex: "^([\\s\\S]{1,60})$",
                                        })
                                    }
                                    success={state?.nameErr === "success"}
                                    error={state.nameErr === "error"}
                                    disabled={pageMode === "view"}
                                />
                                {state.nameErr === "error" && (
                                    <FormControl error>
                                        <FormHelperText>
                                            Name should be a minimum 1 character & maximum 60
                                            characters long.
                                        </FormHelperText>
                                    </FormControl>
                                )}
                            </Grid2>

                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox>
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        Active
                                    </MaterialTypography>
                                </MaterialBox>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={state?.isActive}
                                            onChange={() =>
                                                dispatch({
                                                    type: "switch",
                                                    name: "isActive",
                                                    value: !state?.isActive,
                                                })
                                            }
                                            color="primary"
                                            disabled={pageMode === "view"}
                                        />
                                    }
                                    label={
                                        <MaterialTypography variant="caption" fontWeight="bold">
                                            {state?.isActive ? "Active" : "Inactive"}
                                        </MaterialTypography>
                                    }
                                />
                            </Grid2>
                        </Grid2>
                    </CardContent>

                    <MaterialBox
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        {pageMode !== "view" && (
                            <>
                                <MaterialButton
                                    sx={{ m: 2 }}
                                    variant="outlined"
                                    color="dark"
                                    onClick={() =>
                                        navigate("/insurer-master/insurer-financer")
                                    }
                                >
                                    Cancel
                                </MaterialButton>
                                <MaterialButton
                                    sx={{ m: 2 }}
                                    variant="gradient"
                                    color="dark"
                                    disabled={checkAllFields()}
                                    onClick={handelSubmit}
                                >
                                    {pageMode === "add" ? "Submit" : "Edit"}
                                </MaterialButton>
                            </>
                        )}
                    </MaterialBox>
                </Card>
            </DashboardLayout>
            <DashboardFooter />
        </>
    );
};

export default InsurerFinancerForm;